export default "__VITE_ASSET__2a80136d__"